module.exports = __webpack_public_path__ + "img/Unidad17-3.45ba52c5.png";